// filepath: src/utils/patchUtils.ts

/**
 * Creates a shallow "patch" object containing only keys whose values changed.
 * - Uses strict equality for primitives, and reference equality for objects.
 * - Omits keys where `next[key]` is `undefined`.
 */
export const buildShallowPatch = <T extends Record<string, any>>(
  prev: Partial<T> | undefined,
  next: Partial<T> | undefined
): Partial<T> => {
  const p = (prev || {}) as Record<string, any>;
  const n = (next || {}) as Record<string, any>;

  const out: Record<string, any> = {};
  const keys = new Set([...Object.keys(p), ...Object.keys(n)]);

  keys.forEach((k) => {
    if (n[k] === undefined) return;
    if (p[k] !== n[k]) out[k] = n[k];
  });

  return out as Partial<T>;
};
